var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TextEpsilon',{staticClass:"name",attrs:{"tag":"dt"},domProps:{"textContent":_vm._s(_vm.name)}}),_c('dd',{staticClass:"value"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }